import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BrowserStorage, Instance } from '@const/consts'
import { Language, LanguageShort } from '@const/translations'

import { useAppDispatch, useAppSelector } from '@hooks/redux'

import { setLanguage } from '@store/modules/utils'
import { getPreferredLanguages } from '@utils/utils';
import {
  ILanguageSelectorWrapperProps as IProps,
  ILanguageNames
} from './types'

import { ILibDropdownItem, LanguageSelector } from '@infologistics/frontend-libraries'

const LanguageSelectorWrapper: FC<IProps> = ({ isThemeMini }) => {
  const dispatch = useAppDispatch()
  const { language: savedLanguage } = useAppSelector((state) => state.utils)
  const {
    i18n: {
      changeLanguage,
      language,
      languages
    }, t
  } = useTranslation('language')

  const instanceFromStore = useAppSelector((state) => state.utils.instance)
  const instance = localStorage.getItem(BrowserStorage.INSTANCE) ?? instanceFromStore ?? Instance.GLOBAL

  const [languageNames, setLanguageNames] = useState<Record<string, string>>({})
  const [languageNamesShort, setLanguageNamesShort] = useState<Record<string, string>>({})

  const getLanguageNames = (languages: readonly string[]): ILanguageNames => (
    languages.reduce(
      (acc, language) => ({
        ...acc,
        languageNames: {
          ...acc.languageNames,
          [language]: t(Language[language])
        },
        languageNamesShort: {
          ...acc.languageNamesShort,
          [language]: t(LanguageShort[language])
        }
      }),
      {
        languageNames: {},
        languageNamesShort: {}
      }
    )
  )

  const setStateData = (): void => {
    const { languageNames, languageNamesShort } = getLanguageNames(languages)

    setLanguageNames(languageNames)
    setLanguageNamesShort(languageNamesShort)
  }

  useEffect(setStateData, [language, savedLanguage])

  const handleLanguageChange = (item: ILibDropdownItem): Promise<void> => {
    const { name } = item

    return changeLanguage(name).then(() => {
      localStorage.setItem(BrowserStorage.LANGUAGE, name)
      dispatch(setLanguage(name))
    })
  }

  return (
    <LanguageSelector
      isThemeMini={isThemeMini}
      language={language}
      languages={getPreferredLanguages(instance, language)}
      languageNames={languageNames}
      languageNamesShort={languageNamesShort}
      onLanguageChange={handleLanguageChange}
    />
  )

}

export default LanguageSelectorWrapper
